// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<section id="customer-loans-edit" class="box">
  <sub-header header="\$ctrl.headerLabel()"></sub-header>

  <customer-edit-loan-amortization
    form-amortization="formAmortization"
    sums-valid="sumsValid"
    loan="\$ctrl.clonedLoan"
    edit-principal="\$ctrl.editPrincipal"
  >
  </customer-edit-loan-amortization>

  <div class="buttons">
    <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
    <button class="btn btn-primary" ng-click="\$ctrl.save()"
            ng-disabled="formAmortization.\$invalid || sumsValid === false">
      Save
    </button>
  </div>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/edit/customer-loans-edit-amortization.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;